<template>
  <div class="md-layout-item">
    <form class="modal-content">
      <div class="rejected_box invalid_color"
           v-if="contractData.rejectReason">
        <div>{{ $t("common.rejectionReason") }}:</div>
        <div class="reason_text">{{ contractData.rejectReason }}</div>
      </div>
      <div class="flex_1" style="height: 25px"></div>
      <div class="md-layout-item flex_column" style="width:560px; margin-left: 10rem;">
        <div class="flex_1 margin_r">
          <AvailableDebtorSelect
              :api="loadAvailableDebtors"
              :callback="callback"
              :disabled="isDisabled()"
              :allowAddDebtor="false"
              :label-text="'common.debtor'"
              required
              :value="debtorId"
              data-vv-name="debtor"
              v-validate="modelValidations.debtor"
              v-on:input="changeDebtor"
              :error="errors.first('debtor')"
              ref="CustomerSelectBox"
          ></AvailableDebtorSelect>
        </div>
        <div class="flex_1 margin_r">
          <DebtorContactSelect
              :showAdd="false"
              :disabled="isDisabled()"
              :label-text="'seller.upload.DebtorContact'"
              required
              :value="contactData"
              data-vv-name="contact"
              v-validate="modelValidations.contact"
              v-on:input="changeDebtorContact"
              :error="errors.first('contact')"
              ref="CustomerContactSelectBox"
          ></DebtorContactSelect>
        </div>
        <div class=" margin_r">
          <md-field :class="[{ 'md-error': errors.has('invoiceNumber') }]">
            <label>{{ $t("trackPay.contractsEditModal.contractNumber") }}</label>
            <template>
              <md-input
                  :disabled="isDisabled()"
                  v-model="form.invoiceNumber"
                  :required="true"
                  data-vv-name="invoiceNumber"
                  v-validate="modelValidations.invoiceNumber"
              ></md-input>
              <span v-if="errors.has('invoiceNumber')" class="validation-error">{{
                  errors.first("invoiceNumber")
                }}</span>
            </template>
          </md-field>
        </div>
        <div class="flex_1 margin_r">
          <DatePicker
              v-on:input="changeInvoiceDate"
              :disabled="isDisabled()"
              :value="form.invoiceDate"
              :placeholder="$t('trackPay.contractsEditModal.contractDate')"
              required
              data-vv-name="invoiceDate"
              v-validate="modelValidations.invoiceDate"
              :error="errors.first('invoiceDate')"
          ></DatePicker>
        </div>
        <div class="flex_1 margin_r">
          <md-field :class="[{ 'md-error': errors.has('amount') }]">
            <label>{{ $t("trackPay.contractsEditModal.amount") }}</label>
            <MoneyAmountInput
                v-model="form.amount"
                :disabled="isDisabled()"
                :required="true"
                data-vv-name="amount"
                v-validate="modelValidations.amount"
            ></MoneyAmountInput>
            <span v-if="errors.has('amount')" class="validation-error">{{
                errors.first("amount")
              }}</span>
          </md-field>
        </div>
        <div class="flex_1 margin_r">
          <md-field class="flex_1">
            <label>{{ $t("common.currency") }}</label>
            <TbSelect
                :disabled="isDisabled()"
                v-model="form.currency"
                :search-allow="true"
                :required="true"
                :options="currencyOptions"
                options-value-field="isoCode"
                options-display-field="isoCode"
            />
          </md-field>
        </div>
        <div class="flex_1 margin_r">
          <DatePicker
              v-on:input="changeDeliveryDate"
              :value="form.shipment.estimatedDeliveryDate"
              :disabled="isDisabled()"
              :placeholder="$t('trackPay.contractsEditModal.estimatedDeliveryDate')"
          ></DatePicker>
        </div>
        <div class="flex_1 flex flex_between margin_r">
          <md-field class="flex_1">
            <label>+/-</label>
            <md-input
                :disabled="isDisabled()"
                v-model="form.shipment.deliveryDateTolerance"
                required
            ></md-input>
          </md-field>
          <span>{{
              $t("trackPay.contractsEditModal.estimatedDeliveryDateTip")
            }}</span>
        </div>
        <p class="form_label_head">
          {{ $t("trackPay.contractsEditModal.delivery") }}
        </p>
        <md-field :class="[{ 'md-error': errors.has('companyName') }]">
         <label>{{ $t("common.companyName") }}</label>
         <md-input
          v-model="form.shipment.toAddress.companyName"
          data-vv-name="companyName"
          v-validate="modelValidations.companyName"
          required
          :disabled="isDisabled()"
         ></md-input>
         <span v-if="errors.has('companyName')" class="validation-error">{{ errors.first("companyName") }}</span>
        </md-field>
        <md-field :class="[{ 'md-error': errors.has('firstName') }]">
          <label>{{ $t("common.firstName") }}</label>
          <md-input
            v-model="form.shipment.toAddress.contact.firstName"
            data-vv-name="firstName"
            v-validate="modelValidations.firstName"
            :disabled="isDisabled()"
          ></md-input>
          <span v-if="errors.has('firstName')" class="validation-error">{{ errors.first("firstName") }}</span>
        </md-field>
        <md-field :class="[{ 'md-error': errors.has('lastName') }]">
          <label>{{ $t("common.lastName") }}</label>
          <md-input
            v-model="form.shipment.toAddress.contact.lastName"
            data-vv-name="lastName"
            v-validate="modelValidations.lastName"
            :disabled="isDisabled()"
          ></md-input>
          <span v-if="errors.has('lastName')" class="validation-error">{{ errors.first("lastName") }}</span>
        </md-field>
        <md-field :class="[{ 'md-error': errors.has('streetName') }]">
          <label>{{ $t("common.street") }}</label>
          <md-input
              v-model="form.shipment.toAddress.streetName"
              data-vv-name="streetName"
              v-validate="modelValidations.streetName"
              required
              :disabled="isDisabled()"
          ></md-input>
          <span v-if="errors.has('streetName')" class="validation-error">{{ errors.first("streetName") }}</span>
        </md-field>
        <md-field :class="[{ 'md-error': errors.has('streetNumber') }]">
          <label>{{ $t("common.houseNumber") }}</label>
          <md-input
              v-model="form.shipment.toAddress.streetNumber"
              data-vv-name="streetNumber"
              v-validate="modelValidations.streetNumber"
              required
              :disabled="isDisabled()"
          ></md-input>
          <span v-if="errors.has('streetNumber')" class="validation-error">{{ errors.first("streetNumber") }}</span>
        </md-field>
        <md-field>
          <label>{{ $t("Completion.Company.AddressAddon") }}</label>
          <md-input
              v-model="form.shipment.toAddress.addressExtension"
              :disabled="isDisabled()"
          ></md-input>
        </md-field>
		<md-field :class="[{ 'md-error': errors.has('zipCode') }]">
          <label>{{ $t("trackPay.contractsEditModal.postalCode") }}</label>
          <md-input
              v-model="form.shipment.toAddress.zipCode"
              data-vv-name="zipCode"
              v-validate="modelValidations.zipCode"
              required
              :disabled="isDisabled()"
          ></md-input>
          <span v-if="errors.has('zipCode')" class="validation-error">{{ errors.first("zipCode") }}</span>
        </md-field>
        <md-field :class="[{ 'md-error': errors.has('city') }]">
          <label>{{ $t("common.city") }}</label>
          <md-input
              v-model="form.shipment.toAddress.city"
              data-vv-name="city"
              v-validate="modelValidations.city"
              required
              :disabled="isDisabled()"
          ></md-input>
          <span v-if="errors.has('city')" class="validation-error">{{ errors.first("city") }}</span>
        </md-field>
        <CountrySelect
            v-on:input="onSelectCountry"
            :labelText="$t('common.country')"
            :value="form.shipment.toAddress.country"
            :companyType="enumDef.companyType.DebtorCompany"
            :disabled="isDisabled()"
            :required="true"
            data-vv-name="country"
            v-validate="modelValidations.country"
            :error="errors.first('country')"
        ></CountrySelect>
        <CommonFileUpload
            class="flex_1 margin_r"
            v-model="form.invoiceDocument"
            :disabled="isDisabled()"
            :placeholderKey="`trackPay.contractsEditModal.contractDocument`"
            :uploadFunction="uploadDocument"
            v-validate="modelValidations.invoiceDocument"
            data-vv-name="invoiceDocument"
            :error="errors.first('invoiceDocument')"
            :required="true"
        ></CommonFileUpload>
        <div class="flex_1"></div>
      </div>
    </form>
    <div class="flex flex_between margin_top">
      <md-button class="md-blank" @click="close">{{
          $t("common.button.cancel")
        }}
      </md-button>
      <md-button @click="next" class="md-primary" :class="{ 'md-primary': isFormValid }"
      >{{ $t("common.button.next") }}
      </md-button>
    </div>
  </div>
</template>

<script>
import {validateForm, validateRequiredFields} from "src/validation/validation";
import {enumDef} from "src/common/enumDefs";
import {trackPayApi} from "../../../common/api/trackPayApi";
import DatePicker from "src/components/templates/DatePicker";
import MoneyAmountInput from "src/components/templates/common/MoneyAmountInput";
import CommonFileUpload from "src/components/templates/common/CommonFileUpload";
import CountrySelect from "../select/CountrySelect";
import AvailableDebtorSelect from "../seller/AvailableDebtorSelect";
import DebtorContactSelect from "../select/DebtorContactSelect";

export default {
  props: {
    contractData: {type: Object},
    readOnly: Boolean,
    isEditMode: Boolean,
    error: {type: Boolean, default: ""}
  },
  components: {
    CountrySelect,
    AvailableDebtorSelect,
    DebtorContactSelect,
    DatePicker,
    MoneyAmountInput,
    CommonFileUpload,
  },
  data() {
    return {
      modelValidations: {
        debtor: {
          required: true,
        },
        contact: {
          required: true
        },
        invoiceNumber: {
          required: true
        },
        invoiceDate: {
          required: true
        },
        amount: {
          required: true
        },
        companyName: {
          required: true
        },
        firstName: {
          required: false
        },
        lastName: {
          required: false
        },
        streetName: {
          required: true
        },
        streetNumber: {
          required: true
        },
        zipCode: {
          required: true
        },
        city: {
          required: true
        },
        country: {
          required: true
        },
        invoiceDocument: {
          required: true
        }
      },
      form: {
        debtor: null,
        debtorContact: "",
        invoiceNumber: "",
        invoiceDocument: "",
        invoiceDate: "",
        currency: "EUR",
        shipment: {
          estimatedDeliveryDate: "",
          deliveryDateTolerance: "",
          toAddress: {
            companyName:"",
            contact: {
              firstName: "",
              lastName: "",
            },
            city: "",
            streetName: "",
            streetNumber: "",
            zipCode: "",
            addressExtension: "",
			country: ""
          }
        }
      },
      contactData: null,
      debtorData: null,
      enumDef: enumDef,
      currencyOptions: [
        {isoCode: "EUR"},
        {isoCode: "USD"}
      ]
    };
  },
  methods: {
    changeDebtor(data) {
      if (data) {
        this.debtorData = data;
        this.$store.dispatch("setActionDebtorData", data);
        this.form.debtor = {id: data.id, name: data.name};
        if (!this.form.shipment.toAddress.companyName || this.form.shipment.toAddress.companyName === '') {
          this.form.shipment.toAddress.companyName = data.name;
        }
      }
    },
    changeDebtorContact(data) {
      if (data.id) {
        this.contactData = data;
        this.$store.dispatch("setActionContactData", data);
        this.form.debtorContact = data;
      }
    },
    callback(debtors) {
      if (!debtors || debtors.length == 0) {
        this.toast(this.$t('trackPay.contractsEditModal.salesContract.noDebtor'));
      }
    },
    loadAvailableDebtors() {
      return trackPayApi.seller.getSalesContractDebtorsUrl();
    },
    uploadDocument(params) {
      return trackPayApi.seller.uploadSingleSellerDocument({
        file: params.file,
      });
    },
    changeInvoiceDate(e) {
      this.form.invoiceDate = e;
    },
    changeDeliveryDate(e) {
      this.form.shipment.estimatedDeliveryDate = e;
    },
    getData() {
      return this.form;
    },
    isDisabled() {
      let disabled = false;
      if (this.readOnly) {
        disabled = true;
      }
      return disabled;
    },
    reset() {
      this.readOnly = false;
      this.validate().catch(() => {
        /*ignore error*/
      });
    },
    validate() {
      return validateForm(this, this.$validator);
    },
    onSelectCountry(data) {
      this.form.shipment.toAddress.country = data;
    },
    next() {
      if (this.debtorData.debtorStatus < this.enumDef.companyStatus.Active) {
        this.toast(this.$t('trackPay.contractsEditModal.salesContract.debtorNotActive'));
        return;
      }
      this.validate()
          .then(() => {
            this.$emit("next");
          })
          .catch(this.toast);
    },
    close() {
      this.$emit("close");
    },
    isEditMode() {
      return this.contractData.id;
    },
  },
  watch: {
    contractData() {
      this.form = {...this.form};
    }
  },
  mounted() {
    this.form = {...this.form};

    if (this.contractData.shipment) {
      // EDIT mode: inject values
      this.changeDebtor(this.contractData.debtor);
      this.changeDebtorContact(this.contractData.debtorContact);
    }
  },
  computed: {
    debtorId() {
      return this.debtorData ? this.debtorData.id : null;
    },
    isFormValid() {
      return validateRequiredFields(this.form, this.modelValidations);
    }
  }
};
</script>
